/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  /**
   * Коллекция для подарков
   */
  app.Gifts = app.Collection.extend({
    
    model: app.CartGift,
    
    getGifts: function () {
      $.ajax({
        url: app.entryScriptName + '/api/v3/cart/main/',
        type: 'GET',
        data: {expand: 'gifts'},
        success: function (response) {
          if (response.gifts) {
            app.gifts.reset(response.gifts);
          }
        }
      });
    },
    reset: function (models, options) {
      if (_.isObject(models)) {
        models = _.toArray(models);
      }
      return app.Collection.prototype.reset.apply(this, [models, options]);
    }
  });
  
})(jQuery);

}.call(window));